import { __assign } from "tslib";
import * as ColorSelectors from './color-selectors';
import * as CoreSelectors from './core-selectors';
import * as SpacingSelectors from './spacing-selectors';
import * as BadgeSelectors from './badge-selectors';
import * as TypographySelectors from './typography-selectors';
import * as ShadowSelectors from './shadow-selectors';
import * as FormSelectors from './form-selectors';
import * as LayerSelectors from './layer-selector';
//* ALWAYS IMPORT SELECTORS FROM THIS FILE
export var ThemeSelectors = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, CoreSelectors), SpacingSelectors), BadgeSelectors), TypographySelectors), ShadowSelectors), FormSelectors), LayerSelectors), { 
    // NOTE: The following selectors are deprecated and will be removed in the next major version.
    // They are exported here to allow the `@deprecated` tag to be used in the codebase.
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getBlue: function (theme) { return ColorSelectors.getBlue(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getLightBlue: function (theme) { return ColorSelectors.getLightBlue(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getDarkBlue: function (theme) { return ColorSelectors.getDarkBlue(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getRed: function (theme) { return ColorSelectors.getRed(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getLightRed: function (theme) { return ColorSelectors.getLightRed(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getDarkRed: function (theme) { return ColorSelectors.getDarkRed(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getGreen: function (theme) { return ColorSelectors.getGreen(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getLightGreen: function (theme) { return ColorSelectors.getLightGreen(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getDarkGreen: function (theme) { return ColorSelectors.getDarkGreen(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getYellow: function (theme) { return ColorSelectors.getYellow(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getLightYellow: function (theme) { return ColorSelectors.getLightYellow(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getDarkYellow: function (theme) { return ColorSelectors.getDarkYellow(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getGrey: function (theme) { return ColorSelectors.getGrey(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getLightGrey: function (theme) { return ColorSelectors.getLightGrey(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getDarkGrey: function (theme) { return ColorSelectors.getDarkGrey(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getATBlue: function (theme) { return ColorSelectors.getATBlue(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getATRed: function (theme) { return ColorSelectors.getATRed(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getWhite: function (theme) { return ColorSelectors.getWhite(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getActionColor: function (theme) { return ColorSelectors.getActionColor(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getActionActiveColor: function (theme) { return ColorSelectors.getActionActiveColor(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getActionHoverColor: function (theme) { return ColorSelectors.getActionHoverColor(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getVisitedColor: function (theme) { return ColorSelectors.getVisitedColor(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getFocusColor: function (theme) { return ColorSelectors.getFocusColor(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getGraphicColor: function (theme) { return ColorSelectors.getGraphicColor(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getErrorColor: function (theme) { return ColorSelectors.getErrorColor(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getSuccessColor: function (theme) { return ColorSelectors.getSuccessColor(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getAccentColor: function (theme) { return ColorSelectors.getAccentColor(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getPlaceholderColor: function (theme) { return ColorSelectors.getPlaceholderColor(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getTitleColor: function (theme) { return ColorSelectors.getTitleColor(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getCopyColor: function (theme) { return ColorSelectors.getCopyColor(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getDarkAlertColor: function (theme) { return ColorSelectors.getDarkAlertColor(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getLightAlertColor: function (theme) { return ColorSelectors.getLightAlertColor(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getDarkDefaultColor: function (theme) { return ColorSelectors.getDarkDefaultColor(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getLightDefaultColor: function (theme) { return ColorSelectors.getLightDefaultColor(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getDarkInfoColor: function (theme) { return ColorSelectors.getDarkInfoColor(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getLightInfoColor: function (theme) { return ColorSelectors.getLightInfoColor(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getDarkWarningColor: function (theme) { return ColorSelectors.getDarkWarningColor(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getLightWarningColor: function (theme) { return ColorSelectors.getLightWarningColor(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getColorDecorBgSurface: function (theme) { return ColorSelectors.getColorDecorBgSurface(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getColorDecorBgSurfaceSoft: function (theme) { return ColorSelectors.getColorDecorBgSurfaceSoft(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getColorDecorBgSurfaceSecondary: function (theme) { return ColorSelectors.getColorDecorBgSurfaceSecondary(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getColorDecorBgSurfaceSecondarySoft: function (theme) { return ColorSelectors.getColorDecorBgSurfaceSecondarySoft(theme); }, 
    /*
     * ----------------
     * Legacy selectors
     * ----------------
     *
     * Use the current theme when migration is complete
     * During migration use the theme we're migrating from
     */
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getLegacyRed: function (theme) { return ColorSelectors.getLegacyRed(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getLegacyLightRed: function (theme) { return ColorSelectors.getLegacyLightRed(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getLegacyDarkRed: function (theme) { return ColorSelectors.getLegacyDarkRed(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getLegacyBlue: function (theme) { return ColorSelectors.getLegacyBlue(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getLegacyLightBlue: function (theme) { return ColorSelectors.getLegacyLightBlue(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getLegacyDarkBlue: function (theme) { return ColorSelectors.getLegacyDarkBlue(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getLegacyAqua: function (theme) { return ColorSelectors.getLegacyAqua(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getLegacyLightAqua: function (theme) { return ColorSelectors.getLegacyLightAqua(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getLegacyDarkAqua: function (theme) { return ColorSelectors.getLegacyDarkAqua(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getLegacyGrey: function (theme) { return ColorSelectors.getLegacyGrey(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getLegacyLightGrey: function (theme) { return ColorSelectors.getLegacyLightGrey(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getLegacyDarkGrey: function (theme) { return ColorSelectors.getLegacyDarkGrey(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getLegacyYellow: function (theme) { return ColorSelectors.getLegacyYellow(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getLegacyLightYellow: function (theme) { return ColorSelectors.getLegacyLightYellow(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getLegacyDarkYellow: function (theme) { return ColorSelectors.getLegacyDarkYellow(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getLegacyGreen: function (theme) { return ColorSelectors.getLegacyGreen(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getLegacyLightGreen: function (theme) { return ColorSelectors.getLegacyLightGreen(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getLegacyDarkGreen: function (theme) { return ColorSelectors.getLegacyDarkGreen(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getLegacyInstagramColor: function (theme) { return ColorSelectors.getLegacyInstagramColor(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getLegacyFacebookColor: function (theme) { return ColorSelectors.getLegacyFacebookColor(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getLegacyYouTubeColor: function (theme) { return ColorSelectors.getLegacyYouTubeColor(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getLegacyPiPositiveColor: function (theme) { return ColorSelectors.getLegacyPiPositiveColor(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getLegacyPiBestColor: function (theme) { return ColorSelectors.getLegacyPiBestColor(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getLegacyWhite: function (theme) { return ColorSelectors.getLegacyWhite(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getLegacyCopyLightColor: function (theme) { return ColorSelectors.getLegacyCopyLightColor(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getLegacyPlaceholderColor: function (theme) { return ColorSelectors.getLegacyPlaceholderColor(theme); }, 
    /**
     * @deprecated - Please use the `theme.colors` property directly from the `theme` object
     */
    getLegacyLinkColor: function (theme) { return ColorSelectors.getLegacyLinkColor(theme); } });
